
angular.module('qkr').factory('imageService', ($rootScope, appConfig, utils) => ({
    newImageUrl: null,
    editingImageId: -1,
    editingImageReferenceName: 'TEST',

    fullImageUrl(imageUrl) {
        if (!utils.hasNoValue(imageUrl)) {
            if (imageUrl.indexOf('stock::') == 0) {
                return utils.checkSSL(appConfig.stockImagesUrl) + imageUrl.substring(7);
            } else if (imageUrl.indexOf('http:') != 0 && imageUrl.indexOf('https:') != 0) {
                if (!utils.hasNoValue($rootScope.merchantInfo) && !utils.hasNoValue($rootScope.merchantInfo.baseImageUrl)) {
                    return utils.checkSSL($rootScope.merchantInfo.baseImageUrl) + '/' + imageUrl;
                }
            }
            return imageUrl;
        }
        return '';
    },
    
    stripQueryString(imageUrl) {
    	if (!utils.hasNoValue(imageUrl)) {
	    	const qsIndex = imageUrl.indexOf('?');
	    	if (qsIndex != -1) {
	    		return imageUrl.substring(0, qsIndex);
	    	}
    	}
    	return imageUrl;
    }
}));




// WEBPACK FOOTER //
// ./src/services/imageHelper.js